import styled from 'styled-components';


export const Wrapper = styled.div`
  background: #2E305D;
  color: #FFF;
`;